export const coverageInfoAdapter = (data) => {
	console.log('coverageInfoAdapter', data);
	return [
		{
			key: data?._id + 'coverage',
			coverage_type: data?.info?.coverage_type,
			health_coverage: data?.info?.health_coverage || null,
			plan: data?.info?.plan || null,
			social_number: data?.info?.social_number || null,
			token: data?.info?.token || null,
		},
	];
};
